import React, { useState, useEffect } from 'react'
import { useCustomDispatch } from '../../hooks';
import { SOS_EmergencyEnabled } from '../../services/apis/auth/SOS_EmergencyEnabled';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { ErrorMessage, SuccessMessage } from './AllConfirmationMessages';

import Ably from 'ably';

import * as Icons from '../../assets/svg/icons'
import * as EndPoints from '../../networking/urlEndPoints'
import * as audio from '../../assets/audio';
import { getSafeExternalUrl, getSafeTelHref } from '../../utils/helper/security';

export const playMessageSound = () => {
	const audio = document.getElementById('sosEmergencySound');
	if (audio) {
		audio.play()
			.catch(error => {
				// console.error('Failed to play audio:', error);
			});
	}
}

export const stopMessageSound = () => {
	const audio = document.getElementById('sosEmergencySound');
	if (audio) {
		audio.pause();
		audio.currentTime = 0;
	}
}

let sharedSosRealtime = null;

const getSharedSosRealtime = () => {
	if (!EndPoints.apiKey) {
		return null;
	}

	const state = `${sharedSosRealtime?.connection?.state ?? ''}`.toLowerCase();
	if (!sharedSosRealtime || state === 'closed' || state === 'failed') {
		sharedSosRealtime = new Ably.Realtime({ key: EndPoints.apiKey });
	}

	return sharedSosRealtime;
};

export const SOSemergencyEnableButton = ({ buttonClassName = '' }) => {

	const dispatch = useCustomDispatch()

	const { pharmacyId, driverID } = useAuthSelector()
	const [showToast, setShowToast] = useState({ locationError: false, successToast: false, ApiError: false, showModal: false })

	const [mapUrl, setMapUrl] = useState(null)
	const [driverName, setDriverName] = useState(null)
	const [driverPhone, setDriverPhone] = useState(null)
	const safeMapUrl = getSafeExternalUrl(mapUrl);
	const safeDriverPhoneHref = getSafeTelHref(driverPhone);

	const getLocation = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const latitude = position.coords.latitude;
					const longitude = position.coords.longitude;
					const requesteData = {
						pharmacy_id: pharmacyId,
						latitude: latitude,
						longitude: longitude,
						setShowToast: setShowToast
					}
					if (latitude && longitude && pharmacyId) {
						setShowToast(prevState => ({ ...prevState, successToast: true }));
						setTimeout(() => {
							setShowToast(prevState => ({ ...prevState, successToast: false }))
						}, 2000);

						dispatch(SOS_EmergencyEnabled(requesteData))
					}
				},
				(error) => {
					setShowToast(prevState => ({ ...prevState, locationError: true }));
					setTimeout(() => {
						setShowToast(prevState => ({ ...prevState, locationError: false }));
					}, 3000);
				},
				{ enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
			);
		} else {

		}
	};

	useEffect(() => {
		if (!EndPoints.apiKey || !pharmacyId) {
			return;
		}

		const ably = getSharedSosRealtime();
		if (!ably) {
			return undefined;
		}
		const channel = ably.channels.get('driver-emergency-sos');
		const eventName = `driver-sos-${pharmacyId}`;
		const handler = (message) => {
			if (message.name === eventName && pharmacyId && driverID !== message?.data?.driver_id) {
				setShowToast(prevState => ({ ...prevState, showModal: true }));
				const lat = message.data.latitude
				const long = message.data.longitude

				let googleMapsLink = `https://www.google.com/maps?q=${lat},${long}`;
				setMapUrl(googleMapsLink)
				setDriverName(message?.data?.driver_name)
				setDriverPhone(message?.data?.driver_phone)
				playMessageSound()
			}
		};

		channel.subscribe(eventName, handler)

		return () => {
			channel.unsubscribe(eventName, handler)
		}
	}, [pharmacyId]);


	const handleHideToast = () => {
		setShowToast(prevState => ({ ...prevState, showModal: false }));
		stopMessageSound();
	};

	return (
		<React.Fragment>
			<audio id="sosEmergencySound">
				<source src={audio.alertTune} type="audio/mpeg" />
			</audio>

			<button
				className={`card flex h-8 w-16 items-center justify-center rounded-b-md bg-red-600 px-1.5 text-lg font-bold text-white ${buttonClassName}`.trim()}
				onClick={getLocation}
			>
				SOS
			</button>

			{showToast.showModal &&
				<div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-900 bg-opacity-80 z-50">
					<div className="bg-white rounded-lg p-8 max-w-md mx-4">
						<h2 className="text-2xl font-bold mb-5">{driverName?.charAt(0)?.toUpperCase() + driverName?.slice(1)} may need your help</h2>
						<div className="flex justify-center gap-2">

							<button className="px-5 py-2.5 rounded-md bg-blue-600" onClick={stopMessageSound}>
								<a href={safeDriverPhoneHref || '#'}>
									<Icons.PhoneIcon color='white' />
								</a>
							</button>

							<button onClick={stopMessageSound} className="px-5 py-3 font-bold bg-green-600 text-white rounded hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-400">
								<a href={safeMapUrl || '#'} target='_blank' rel="noopener noreferrer">Get Location</a>
							</button>
							<button onClick={handleHideToast}
								className="px-5 py-3 font-bold bg-red-600 text-white rounded hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-400">
								X
							</button>
						</div>
					</div>
				</div>
			}

			{
				showToast.successToast &&
				<SuccessMessage message='Notification sent Successfully' setShowToast={() => setShowToast(prevState => ({ ...prevState, successToast: false }))} />
			}

			{
				showToast?.locationError &&
				<ErrorMessage message={'Please Enable the Location'} setShowToast={() => setShowToast(prevState => ({ ...prevState, locationError: false }))} />
			}

			{
				showToast?.ApiError &&
				<ErrorMessage message={'Oops! Notification failed please try again.'} setShowToast={() => setShowToast(prevState => ({ ...prevState, ApiError: false }))} />
			}

		</React.Fragment >
	)
}
